import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { REMOVE_NOTIFICATION } from "../../../store/types";
import styles from "./Notification.module.scss";

const Notification = ({ notification }) => {
    const [reducing, setReducing] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setTimeout(() => {
            setReducing(true);
        }, 1000);

        setTimeout(() => {
            dispatch({
                type: REMOVE_NOTIFICATION,
                payload: notification.id,
            });
        }, 6000);
        // eslint-disable-next-line
    }, []);
    const getLabelText = (label) => {
        if (typeof label === "string") return label;
        if (label == null) return "";

        if (typeof label === "object") {
            if (typeof label.message === "string") return label.message;
            if (Array.isArray(label.errors) && label.errors.length > 0) {
                const firstError = label.errors[0];
                if (typeof firstError === "string") return firstError;
                if (firstError && typeof firstError.message === "string") {
                    return firstError.message;
                }
            }
        }

        try {
            return JSON.stringify(label);
        } catch {
            return String(label);
        }
    };

    return (
        <div className={`${styles.notification} ${styles[notification.type]}`}>
            {getLabelText(notification.label)}
            <div className={styles.meter}>
                <div
                    style={{ width: reducing ? "0%" : "100%" }}
                    className={styles.lever}
                ></div>
            </div>
        </div>
    );
};

export default Notification;
